module.exports = __webpack_public_path__ + "static/img/goods-100.87fe73d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-100.png
// module id = W6X5
// module chunks = 2